/**
 * Modal Component
 */
let currentOpenModal = null

// get modal element from toggle button
const getModal = (el, id) => {
  const modal = document.querySelector(id)

  // check if the given id exists, and return that element if it does
  if (modal !== null) {
    return modal
  } else {
    console.error(
      `The element ${el.getAttribute('aria-label') ||
        el.innerText} is targeting a modal id of ${id}, which does not exist.`
    )
  }
}

// open the given modal
const openModal = el => {
  document.getElementsByTagName('html')[0].classList.add('overflow-hidden')
  el.classList.remove('is-closed')
  el.setAttribute('aria-hidden', false)
  currentOpenModal = el
}

// close the given modal
const closeModal = el => {
  document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
  el.classList.add('is-closed')
  el.setAttribute('aria-hidden', true)
  currentOpenModal = null
}

// toggles the modal open or closed
const toggleModal = el => {
  // check if the modal element has the --open class
  let isClosed = el.classList.contains('is-closed')

  // toggle class and aria label, based on if modal is open or not
  if (isClosed) {
    openModal(el)
  } else {
    closeModal(el)
  }
}

const modalToggleButtons = document.querySelectorAll('[data-modal="toggle"]')
const modalOverlays = document.querySelectorAll('[data-modal="overlay"]')

// attaches click events to all buttons that have have the data-toggle="modal" attr
// opens modal that corresponds to this buttons data-target attr
// includes buttons that open the modal, and the close button inside the modal
modalToggleButtons.forEach(i => {
  const targetId = i.dataset.target
  const targetEl = getModal(i, targetId)

  i.addEventListener('click', () => {
    toggleModal(targetEl)
  })
})

// adds a click event to any modal overlays, that will close the current opened modal
modalOverlays.forEach(o => {
  o.addEventListener('click', () => {
    closeModal(currentOpenModal)
  })
})

// listens for esc key to close the currently open modal
document.addEventListener('keyup', e => {
  // listen for esc key, and ensure that a modal is currently open
  if (e.keyCode === 27 && currentOpenModal !== null) {
    // close the currently open modal
    closeModal(currentOpenModal)
  }
})
